import { ApiService } from "@/lib/api.service";
import {
  AuthResponse,
  LoginRequest,
  LogoutRequest,
  OtpLoginRequest,
  OtpRequestRequest,
  OtpRequestResponse,
  OtpSignupRequest,
  OtpVerifyRequest,
  OtpVerifyResponse,
  ProfileData,
  RefreshTokenRequest,
  RefreshTokenResponse,
  UpdatePasswordRequest,
  UpdateProfileRequest,
  User,
} from "./auth.model";

class AuthServiceClass extends ApiService {
  // ⚠️ اصلاح شد: باید دقیقاً با روت‌های واقعی لاراول هماهنگ باشه
  private readonly basePath = "";

  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await this.post(`${this.basePath}/login`, data);
    return response.data;
  }

  async requestOtp(data: OtpRequestRequest): Promise<OtpRequestResponse> {
    const response = await this.post(`${this.basePath}/otp/request`, data);
    return response.data;
  }

  async verifyOtp(data: OtpVerifyRequest): Promise<OtpVerifyResponse> {
    const response = await this.post(`${this.basePath}/otp/verify`, data);
    return response.data;
  }

  async loginWithOtp(data: OtpLoginRequest): Promise<AuthResponse> {
    const response = await this.post(`${this.basePath}/otp/login`, data);
    return response.data;
  }

  async signupWithOtp(data: OtpSignupRequest): Promise<AuthResponse> {
    const response = await this.post(`${this.basePath}/otp/signup`, data);
    return response.data;
  }

  async refreshToken(data: RefreshTokenRequest): Promise<RefreshTokenResponse> {
    const response = await this.post(`${this.basePath}/refresh`, data);
    return response.data;
  }

  async logout(data?: LogoutRequest): Promise<{ message: string }> {
    const response = await this.post(`${this.basePath}/logout`, data || {});
    return response.data;
  }

  // ⚠️ اصلاح شد: مسیر واقعی /me است، نه /auth/me
  async getProfile(): Promise<ProfileData> {
    const response = await this.get(`${this.basePath}/me`);
    return response.data;
  }

  async updateProfile(data: UpdateProfileRequest): Promise<User> {
    const response = await this.put(`${this.basePath}/profile`, data);
    return response.data;
  }

  async updatePassword(data: UpdatePasswordRequest): Promise<{ message: string }> {
    const response = await this.put(`${this.basePath}/password`, data);
    return response.data;
  }

  async uploadAvatar(file: File): Promise<{ avatar: string }> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await this.post(`${this.basePath}/avatar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async deleteAvatar(): Promise<{ message: string }> {
    const response = await this.delete(`${this.basePath}/avatar`);
    return response.data;
  }
}

export const AuthService = new AuthServiceClass();